import { LoadCssResolver } from '@b2b/common/resolvers';
import { ApiService } from '@b2b/common/services/api/types';
import { TODO } from '@b2b/types/core';
import uiRouter, { StateProvider } from '@uirouter/angularjs';
import angular from 'angular';
import { ProgramsListControllerModule } from '../../programs/list/controllers/ProgramsListController';

export const RetailEventsView = angular
  .module('acme.view.application.retail.events', [
    uiRouter,
    'ui.bootstrap',
    'acme.common.service.api',
    'acme.common.service.helpers',
    'acme.view.application.retail.events.controllers',
    ProgramsListControllerModule,
  ])
  .config(function config($stateProvider: StateProvider) {
    // Create both abstract view and template view.
    // Abstract Views are enabled by default
    $stateProvider.state({
      name: 'application.retail.events',
      url: '/events',
      views: {
        'subview-main': {
          controller: 'ProgramsListController',
          // Assumes the view is entirely self contained
          templateUrl: 'views/application/views/programs/list/list.tpl.html',
        },
      },
      data: {
        pageTitle: 'Events',
        /** Secure With Permissions **/
        permissions: [
          'EVENT_VIEW',
          'EVENT_DELETE',
          'ORDER_REBOOK',
          'ORDER_CREATE',
          'ORDER_UPDATE',
          'ACCT_ORDERS_CREATE',
          'ACCT_ORDERS_UPDATE',
          'ORDER_VIEW',
        ],
        enablePreferences: true,
      },
      resolve: {
        CustomFieldsData: [
          'ApiService',
          'HelpersService',
          function (ApiService: ApiService, HelpersService: TODO) {
            return ApiService.customFields.list(HelpersService.getPaginator());
          },
        ],
        istevenMultiselectCss: LoadCssResolver({ id: 'isteven-multi-select', url: '/assets/isteven-multi-select.css' }),
      },
    });
  }).name;
